import {ModuleWithProviders, NgModule, Optional, SkipSelf} from "@angular/core";
import {ValidationService} from "./validation.service";

@NgModule({})
export class ValidationModule {
    constructor(@Optional() @SkipSelf() parentModule: ValidationModule) {
        if (parentModule) {
            throw new Error('ValidationModule is already loaded. Import it in the AppModule only');
        }
    }

    /**
     * Provide the validation service and the application key used for field name translation lookup.
     * @param config
     * @return ModuleWithProviders
     */
    static forRoot(config: ValidationConfig): ModuleWithProviders<ValidationModule> {
        return {
            ngModule: ValidationModule,
            providers: [
                ValidationService,
                {provide: ValidationService.APPLICATION_KEY, useValue: config.application}
            ]
        };
    }
}

export class ValidationConfig {
    application: string;
}
